<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-form>
      <v-card>
        <v-card-text>
          <mrc_ess_switch v-model="levelcomponentslist.is_used" :true-value="1" :false-value="0" v-if="$store.state.uuid"
            :readonly="readonly" :true-text="$t('label_To_enable_the')" :false-text="$t('label_disable')">
          </mrc_ess_switch>
          <v-row>
            <v-col cols="12" sm="6" class="mt-1">
              <mrc_ess_multiText :label="$t('label_The_name_of_the_hierarchy') + '*'"
                :isNational="judegNational('job_grade_name')" v-model="levelcomponentslist.job_grade_name"
                :error-messages="$errors(
                  'levelcomponentslist',
                  'job_grade_name',
                  requiredRule.concat(nocharacter)
                )
                  " :readonly="readonly"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12" sm="6">
              <!--   between: between(0, 999), -->
              <mrc_ess_NumInput :label="$t('label_The_hierarchy') + '*'" :error-messages="$errors(
                'levelcomponentslist',
                'job_grade_class',
                between('000-999').concat(requiredRule)
              )
                " v-model="levelcomponentslist.job_grade_class" :readonly="readonly"></mrc_ess_NumInput>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <!-- requiredRule.concat(nocharacter) -->
              <!--     :error-messages="
                  $errors('levelcomponentslist', 'job_grade_name', requiredRule.concat(nocharacter))
                "-->
              <!-- 
                 nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        }, 
        -->
              <mrc_ess_multiText :label="$t('label_note')" noRequired :isNational="judegNational('remark')"
                :error-messages="$errors('levelcomponentslist', 'remark', nocharacter)
                  " v-model="levelcomponentslist.remark" :readonly="readonly"></mrc_ess_multiText>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <mrc_ess_autoComplete :label="$t('label_company') + '*'" :readonly="readonly" orgView multiple
                v-model="levelcomponentslist.org_level_uuid" :error-messages="$errors('levelcomponentslist', 'org_level_uuid', requiredRule)
                  " :prompt_name="org_levels_sub">
              </mrc_ess_autoComplete>
            </v-col>
          </v-row>
          <v-row v-if="readonly">
            <v-col cols="12" sm="6">
              <mrc_ess_NumInput v-model="levelcomponentslist.staff_number" :label="$t('label_Number_of_posts_in_use')"
                :readonly="true">
              </mrc_ess_NumInput>
            </v-col>
            <v-col cols="12" sm="6">
              <mrc_ess_NumInput :label="$t('label_The_sorting') + '*'" v-model="levelcomponentslist.sequence"
                :readonly="readonly"></mrc_ess_NumInput>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="6">
              <mrc_ess_NumInput :label="$t('label_The_sorting') + '*'" :error-messages="$errors(
                'levelcomponentslist',
                'sequence',
                between('000-999').concat(requiredRule)
              )
                " v-model="levelcomponentslist.sequence" :readonly="readonly"></mrc_ess_NumInput>
            </v-col>
          </v-row>
        </v-card-text>
        <mrc_ess_submitBtn @success="success" @cancel="cancel" :loading="btnIsLoading" v-if="!readonly">
        </mrc_ess_submitBtn>
      </v-card>
    </v-form>
  </mrc_ess_skeleton_loader>
</template>

<style scoped>
.bt1 {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-color: #ccc;
  line-height: 25px;
  text-align: center;
}

.sequenceinput {
  border-top: 1px black solid;
  border-bottom: 1px black solid;
  text-align: center;
}
</style>

<script>
import {
  update_postgrades,
  get_postgradesdetail,
  get_postgrades_groupdetail,
  update_postgrades_group,
  add_postgrades,
  add_postgrades_group,
} from "@/service/api/postgrades.js";
import {
  required,
  maxLength,
  between,
  email,
  url,
  numeric,
} from "vuelidate/lib/validators";

export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      skeletonloading: true,
      btnIsLoading: false,
      levelcomponentslist: {
        job_grade_name: "", //级别名称
        job_grade_shortcode: "", //级别短编码
        job_grade_class: "", //级别
        is_used: 1, //是否启用 0 否 1 是
        sequence: "", //排序
        remark: "", //备注
        org_level_uuid: "", //关联公司UUID
      },
    };
  },
  validations: {
    levelcomponentslist: {
      // group_name: {
      //   maxLength: maxLength(20),
      //   required
      // },
      job_grade_shortcode: {},
      job_grade_name: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
        required,
      },
      job_grade_class: {
        between: between(0, 999),
        required,
      },
      remark: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      sequence: {
        between: between(0, 999),
        required,
      },
      staff_number: {
        // maxLength: maxLength(10),
        // between: between(0, 100000),
      },
      org_level_uuid: {
        required,
      },
    },
  },
  created() { },
  async mounted() {
    this.national("mrbase_sys_job_post_grades");
    if (this.$store.state.uuid) {
      await this.getlist();
    } else {
    }
    if (String(this.levelcomponentslist.is_used)) {
      this.levelcomponentslist.is_used = Number(
        this.levelcomponentslist.is_used
      );
    }
  },
  methods: {
    async getlist() {
      this.skeletonloading = true;
      const res = await get_postgradesdetail({ uuid: this.$store.state.uuid });
      this.levelcomponentslist = {
        ...res.data,
        staff_number: Number(this.$store.state.uuid2),
      };
      // this.$set(this.levelcomponentslist, 'staff_number', Number(this.$store.state.uuid2))
      // String(this.levelcomponentslist.org_level_uuid).indexOf(',') != -1
      //   ? (this.levelcomponentslist.org_level_uuid = this.levelcomponentslist.org_level_uuid.split(
      //     ','
      //   ))
      //   : (this.levelcomponentslist.org_level_uuid = [
      //     this.levelcomponentslist.org_level_uuid,
      //   ])

      // console.log(this.levelcomponentslist.staff_number, this.levelcomponentslist);
      this.skeletonloading = false;
    },
    async success() {
      //提交
      this.$v.levelcomponentslist.$touch();
      this.$v.$touch();
      if (this.$v.levelcomponentslist.$error) return;
      this.btnIsLoading = true;
      // Array.isArray(this.levelcomponentslist.org_level_uuid)
      //   ? (this.levelcomponentslist.org_level_uuid = this.levelcomponentslist.org_level_uuid.join())
      //   : ''
      delete this.levelcomponentslist.staff_number;
      if (this.$store.state.uuid) {
        delete this.levelcomponentslist.created_by;
        delete this.levelcomponentslist.updated_utc_datetime;
        delete this.levelcomponentslist.updated_by;
        delete this.levelcomponentslist.created_utc_datetime;
        const res = await update_postgrades(this.levelcomponentslist);
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          this.$emit("changeReadonly");
          await this.getlist();
        }
        this.btnIsLoading = false;
      } else {
        const res = await add_postgrades(this.levelcomponentslist);
        if (res.code == 200) {
          this.$router.push({
            name: "Post_level_management",
          });
        }
        this.btnIsLoading = false;
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        this.$emit("changeReadonly");
        await this.getlist();
      } else {
        //取消
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "Post_level_management",
            });
          })
          .catch((err) => { });
      }
    },
  },
  computed: {
    org_levels_sub() {
      return {
        prompt_name: "org_levels_sub",
        org_level_uuid: this.$store.state.currentCompany,
        // prompt_name: "org_levels_manager_filter_company_code",
        // user_id: this.$store.state.userData.user_id,
        // org_level_code: this.$store.state.currentCompanyObj.org_level_code,
      };
    },
    unit() {
      let user_uuid =
        this.$store.state.userData.uuid ||
        JSON.parse(this.$ls.get("userData")).uuid;
      return { prompt_name: "org_levels_manager_filter_company", user_uuid };
    },
    company_uuid() {
      //当前de公司
      return this.$store.state.currentCompany;
    },
  },
};
</script>

<style scoped></style>
